import { render, staticRenderFns } from "./LumaChatWidget.vue?vue&type=template&id=38fdaf0f&scoped=true&"
import script from "./LumaChatWidget.vue?vue&type=script&lang=js&"
export * from "./LumaChatWidget.vue?vue&type=script&lang=js&"
import style0 from "./LumaChatWidget.vue?vue&type=style&index=0&id=38fdaf0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fdaf0f",
  null
  
)

export default component.exports